// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2P5Lx","header":"MergedInvoice_header__1SGFU"};